export default "__VITE_ASSET__U154uvKy__"